const ConfirmSegregateModalForm = ({
  setOpenConfirmSegregateModal,
  handleSegregate,
  isLoading
}) => {

  const cancel = () => {
    setOpenConfirmSegregateModal(false);
  };

  return (
    <>
      <div
        className="d-flex flex-column scroll-y me-n7 pe-7"
        id="kt_modal_add_user_scroll"
        data-kt-scroll="true"
        data-kt-scroll-activate="{default: false, lg: true}"
        data-kt-scroll-max-height="auto"
        data-kt-scroll-dependencies="#kt_modal_add_user_header"
        data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
        data-kt-scroll-offset="300px"
      >
        <div>
          <h4>
            Are you sure you want to segregate this listing?
          </h4>
          <div className="text-center pt-5">
            <button
              type="reset"
              onClick={() => cancel()}
              className="btn btn-light me-3"
              data-kt-users-modal-action="cancel"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={'btn btn-main text-white'}
              disabled={isLoading}
              id='approve'
              data-kt-users-modal-action="submit"
              onClick={handleSegregate}
            >
              <span className="indicator-label">Confirm</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export { ConfirmSegregateModalForm };
